import request from '@/utils/request'

export default function agencyListChatGroupMessage(groupId, sendTime) {
  return request({
    url: `/chatGroupMessage/agency/list/${groupId}/${sendTime || 0}`,
    method: 'get',
  })
}
